import {doGet} from './Base';


const getUsers = async () => {
  const url = '/account/users';
  return await doGet(url, true);
};


export default getUsers;
